






import { Component, Vue } from 'vue-property-decorator'

@Component({
  name:'Layout'
})
export default class Layout extends Vue {

}
